// Hook - szczegoly wybranego handlowca.
// GET /api/ui/trader-management/traders/{traderId}

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { IGetTraderManagementTraderSummaryResponse } from 'api/types/traderManagement';

const getTraderManagementTraderSummary = (
  traderId: number
): Promise<IGetTraderManagementTraderSummaryResponse> =>
  axios.get(`/trader-management/traders/${traderId}`);

export const useGetTraderManagementTraderSummary = (
  traderId: number,
  options?: UseQueryOptions<IGetTraderManagementTraderSummaryResponse, IError>
) =>
  useQuery<IGetTraderManagementTraderSummaryResponse, IError>(
    ['trader-management-trader-summary', traderId],
    () => getTraderManagementTraderSummary(traderId),
    { enabled: traderId > 0, ...(options ?? {}) }
  );
